var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "提示文字" } },
        [
          _c("el-input", {
            attrs: {
              size: "small",
              placeholder: "请设置提示语",
              maxlength: "50",
              "show-word-limit": "",
            },
            model: {
              value: _vm.value.placeholder,
              callback: function ($$v) {
                _vm.$set(_vm.value, "placeholder", $$v)
              },
              expression: "value.placeholder",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { staticClass: "options", attrs: { label: "选项设置" } },
            [
              _c(
                "div",
                {
                  staticClass: "option-item-label",
                  attrs: { slot: "label" },
                  slot: "label",
                },
                [_c("span", [_vm._v("选项名称")])]
              ),
              _c(
                "draggable",
                {
                  attrs: {
                    list: _vm.value.options,
                    group: "option",
                    handler: ".el-icon-rank",
                    options: _vm.dragOption,
                  },
                },
                _vm._l(_vm.value.options, function (op, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "option-item" },
                    [
                      _vm.formName === "SelectInput"
                        ? _c("el-radio", {
                            staticClass: "none-label",
                            attrs: { label: index },
                            model: {
                              value: _vm.radio,
                              callback: function ($$v) {
                                _vm.radio = $$v
                              },
                              expression: "radio",
                            },
                          })
                        : _vm.formName === "MultipleSelect"
                        ? _c("el-checkbox", {
                            staticClass: "none-label",
                            attrs: { label: index },
                            model: {
                              value: _vm.checked,
                              callback: function ($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked",
                            },
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "icon-move" }),
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          placeholder: "请设置选项值",
                          clearable: "",
                          maxlength: "24",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.value.options[index],
                          callback: function ($$v) {
                            _vm.$set(_vm.value.options, index, $$v)
                          },
                          expression: "value.options[index]",
                        },
                      }),
                      _c("div", {
                        staticClass: "icon-delete",
                        on: {
                          click: function ($event) {
                            return _vm.value.options.splice(index, 1)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
              _c("div", { staticClass: "btn-content" }, [
                _c("div", { staticClass: "btn", on: { click: _vm.onEdit } }, [
                  _vm._v("批量编辑"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        _vm.value.options.push(
                          "选项" + (_vm.value.options.length + 1)
                        )
                      },
                    },
                  },
                  [_vm._v("添加选项")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("popBatchEdit", { ref: "popBatchEdit", on: { ok: _vm.setEdit } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }